import videojs from "video.js";
import moment from "moment-timezone";
import Vue from "vue";

export function playVideo(vm, bassUrl) {
  if (vm.player) {
    vm.cameraMsg = "";
    const video = {
      withCredentials: false,
      type: "application/x-mpegurl",
      src: bassUrl + "/webcam/hls/stream.m3u8",
    };
    vm.hlsSrc = bassUrl + "/webcam/hls/stream.m3u8";
    vm.player.src(video);
    vm.player.poster(bassUrl + "/webcam/thumbnail/thumbnail.png");
  }
}

export function playVideoHls(vm, baseUrl, trackUrl) {
  if (vm.player) {
    vm.cameraMsg = "";
    vm.player.reset();
    const video = {
      withCredentials: false,
      type: "application/x-mpegurl",
      src: trackUrl ? trackUrl : baseUrl,
    };
    vm.hlsSrc = baseUrl;
    vm.player.src(video);
    let path = baseUrl.split("/");
    path.pop();
    const thumbnailUrl = vm.convertGcsPath(path.join("/")) + "/thumbnail.png";
    vm.player.poster(thumbnailUrl);
  }
}

export function playVideoEcomott(vm, baseUrl) {
  if (vm.player) {
    vm.cameraMsg = "";
    const video = {
      withCredentials: false,
      type: "application/x-mpegurl",
      src: baseUrl,
    };
    vm.hlsSrc = baseUrl;
    vm.player.src(video);

    const path = baseUrl.split("/");
    path.pop();
    vm.player.poster(path.join("/") + "/thumbnail.png");

    showPlayButton(vm);
  }
}

export function showPlayButton(vm) {
  let playButton = vm.player
    .contentEl()
    .getElementsByClassName("vjs-big-play-button");
  if (playButton[0]) playButton[0].style.display = "block";
}

export function hidePlayButton(vm) {
  let playButton = vm.player
    .contentEl()
    .getElementsByClassName("vjs-big-play-button");
  if (playButton[0]) playButton[0].style.display = "none";
}

export function errorHandler(vm) {
  if (vm.player) {
    vm.player.reset();
    let ErrorDisplay = videojs.getComponent("ErrorDisplay");
    vm.errorDisplay = new ErrorDisplay(vm.player, {
      temporary: false,
    });
    vm.player.addChild(vm.errorDisplay);
    vm.cameraMsg = "";
    vm.player.error(vm.getCameraErrorMessage(vm.camera.movieType));
    vm.retryText = "もう一度接続";
    vm.hasVideoError = true;
  }
}

export async function hasValidMovie(vm, url, movieType) {
  const graceMinutes = 30;

  // m3u8の最後の動画ファイル名を取得する。
  const playListText = await fetch(url, { mode: "cors" }).then(res =>
    res.text()
  );
  const playListLines = playListText.split("\n").filter(x => x.match(/\.ts$/));

  if (movieType === vm.CAMERA_MOVIE_TYPE.SAFIE && playListLines.length > 0) {
    // Safieは ファイル名から時間を割り出せないので、firestore.metadataで判定
    if (playListLines.length === 0) {
      return false;
    } else {
      const webcamChildPath = decodeURIComponent(
        playListLines[playListLines.length - 1].replace(
          new RegExp(process.env.VUE_APP_CLOUD_SOTRAGE_WEBCAM_URL),
          ""
        )
      );
      const ref = vm.$storageWebCam.child(webcamChildPath);
      const metadata = await ref.getMetadata();
      const diffMinutes =
        (moment().valueOf() - moment(metadata["updated"]).valueOf()) /
        (60 * 1000);
      return diffMinutes < graceMinutes;
    }
  }

  const lastMovieFileName =
    playListLines.length > 0 ? playListLines[playListLines.length - 1] : null;
  if (lastMovieFileName) {
    // https://storage.googleapis.com/aisea-webcam/fa2dd7ab01437c01d86726af6e7e63e2f145347fb4e4a82a6589d6260abec3f1/20220817/17/20220817-173000%2C10.ts
    // 20220817-173000%2C10.ts
    const ymdhmsZ =
      lastMovieFileName
        .replace(/^.*\//, "")
        .replace(/-/g, "_")
        .replace(/^([0-9_]+).*$/, "$1") + "Z";
    const lastMomentValue = moment(ymdhmsZ, "YYYYMMDD_HHmmssZ").valueOf();
    if (lastMomentValue + graceMinutes * 60 * 1000 > moment().valueOf()) {
      // m3u8の最後の動画ファイル名 から読み取れる時間が直近であれば、Live有効な動画と判定
      return true;
    } else {
      Vue.$log.debug(
        "movie latest timestamp",
        vm.camera.id,
        vm.camera.movieType,
        ymdhmsZ,
        ((moment().valueOf() - lastMomentValue) / (60 * 1000)).toFixed(1) +
          "min."
      );
    }
  }
  return false;
}
